import { Box, Button, Flex, Icon, Image, Stack, Text, useBreakpointValue } from "@chakra-ui/react";
import { ArrowRightIcon } from "@phosphor-icons/react/dist/ssr";

import { isPortrait } from "@/utilities/useOrientation";

const Inicio_v2 = ({ branding_props, setIsInit }) => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const orientation = isPortrait() ? "portrait" : "landscape";

    return (
        <Box
            minHeight={{ base: "100vh", lg: "99vh" }}
            maxH="100%"
            bg={
                branding_props?.init_props?.styles?.background
                    ? branding_props?.init_props?.styles?.background
                    : branding_props.brand || "#002B49"
            }
            rounded={{ base: "0", lg: "2xl" }}
            alignContent="center"
            mt={{ base: "0", lg: "0.5vh" }}
            maxW={{ base: "100%", lg: "99vw" }}
            mx={{ base: "0", lg: "0.5vw" }}
        >
            <Stack>
                {isGreaterThanMd &&
                    branding_props?.complements?.init &&
                    branding_props?.complements?.init?.map((complement, index) => {
                        let style_props = {};
                        Object.keys(complement?.props)?.map((key) => {
                            style_props = { ...style_props, [key]: complement?.props[key] };
                        });
                        return (
                            <Image
                                alt="complement"
                                src={complement.url}
                                style={{ ...style_props }}
                                key={index}
                            />
                        );
                    })}
                {branding_props?.complements?.init &&
                    !isGreaterThanMd &&
                    branding_props?.complements?.init?.map((complement, index) => {
                        let style_props_mobile = {};
                        Object.keys(complement?.mobile_props)?.map((key) => {
                            style_props_mobile = {
                                ...style_props_mobile,
                                [key]: complement?.mobile_props[key],
                            };
                        });
                        return (
                            <Image
                                alt="complement"
                                src={complement.url}
                                style={{ ...style_props_mobile }}
                                key={index}
                            />
                        );
                    })}
            </Stack>
            <Stack gap="3vh">
                <Stack align="center" spacing={1} mb={10} mx={4} paddingBottom="2vh">
                    <Image
                        alt="logo"
                        src={branding_props.logo}
                        maxH={{
                            base: "20vh",
                            md: isGreaterThanMd && orientation == "portrait" ? "25vh" : "15vh",
                        }}
                        minH="9vh"
                        maxW={{
                            base: "75%",
                            md: isGreaterThanMd && orientation == "portrait" ? "70%" : "20vw",
                        }}
                    />
                </Stack>
                <Stack
                    align="center"
                    spacing={1}
                    mt={4}
                    mx={4}
                    alignSelf="center"
                    maxW={{ base: "70%", md: "auto" }}
                >
                    {branding_props?.text?.title_bold || branding_props?.text?.title ? (
                        <Text
                            color={branding_props.brand_text || "#FFFFFF"}
                            fontSize={{
                                base: "2.5vh",
                                md: isGreaterThanMd && orientation == "portrait" ? "2.3vh" : "4vh",
                            }}
                            fontWeight={400}
                            textAlign="center"
                            whiteSpace="pre-line"
                            fontFamily={branding_props.title_font || ""}
                            lineHeight={{ base: 1, md: 1.5 }}
                            dangerouslySetInnerHTML={{
                                __html: `<strong>${branding_props?.text?.title_bold || ""}</strong> ${!isGreaterThanMd && branding_props?.text?.title_bold && branding_props?.text?.title ? "<br/>" : ""} ${branding_props?.text?.title || ""} ${!isGreaterThanMd ? "<br/> <br/>" : ""}`,
                            }}
                        />
                    ) : (
                        <>
                            {/* Más opciones de texto */}
                            <Text
                                color={branding_props.brand_text || "#FFFFFF"}
                                fontSize={{ base: "2.8vh", md: "4.8vh" }}
                                fontWeight={400}
                                textAlign="center"
                                whiteSpace="pre-line"
                                fontFamily={branding_props.primary_font || "Montserrat"}
                            >
                                {branding_props?.text?.primary}
                            </Text>
                            <Text
                                color={branding_props.brand_text || "#FFFFFF"}
                                fontSize={{ base: "3vh", md: "4.8vh" }}
                                fontWeight={400}
                                textAlign="center"
                                whiteSpace="pre-line"
                                fontFamily={branding_props.secondary_font || "Montserrat"}
                                paddingBottom="2vh"
                            >
                                {branding_props?.text?.secondary}
                            </Text>
                        </>
                    )}
                    {branding_props?.text?.subtitles?.map((subtitle, index) => {
                        return (
                            <Text
                                color={branding_props.brand_text || "#FFFFFF"}
                                fontSize={{ base: "1.3vh", md: "2vh" }}
                                fontWeight={400}
                                fontFamily={branding_props.brand_font_subtitles || "Montserrat"}
                                whiteSpace={{ base: "pre-line", md: "normal" }}
                                key={index}
                            >
                                {subtitle}
                                <br />
                            </Text>
                        );
                    })}
                </Stack>
                <Stack align="center" spacing={1} mt={4} mx={4} paddingTop="3vh">
                    {!branding_props.arrow_icon ? (
                        <Button
                            bg="transparent"
                            borderRadius="full"
                            borderWidth={1}
                            borderStyle="solid"
                            height="8vh"
                            w="8vh"
                            borderColor={
                                branding_props?.arrow_color
                                    ? branding_props?.arrow_color
                                    : branding_props.brand_text || "#FFFFFF"
                            }
                            _hover={{
                                color: branding_props?.arrow_color
                                    ? branding_props?.arrow_color
                                    : branding_props.accent || "#F1F1F1",
                                transform: "scale(1.1)",
                            }}
                        >
                            <Icon
                                color={
                                    branding_props?.arrow_color
                                        ? branding_props.arrow_color
                                        : branding_props.brand_text || "#FFFFFF"
                                }
                                fontSize="5vh"
                                cursor="pointer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsInit(true);
                                }}
                                _hover={{
                                    color: branding_props?.arrow_color
                                        ? branding_props.arrow_color
                                        : branding_props.accent || "#F1F1F1",
                                    transform: "scale(1.01)",
                                }}
                                zIndex={1}
                                boxSize={isGreaterThanMd && orientation == "portrait" ? 24 : 12}
                            >
                                <ArrowRightIcon weight="bold" />
                            </Icon>
                        </Button>
                    ) : (
                        <Button
                            bg="transparent"
                            borderRadius="full"
                            bordeWidthr={1}
                            borderColor={
                                branding_props?.arrow_color
                                    ? branding_props?.arrow_color
                                    : branding_props.brand_text || "#FFFFFF"
                            }
                        >
                            <Image
                                maxW="5vw"
                                minW="3vw"
                                src={branding_props.arrow_icon}
                                cursor="pointer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsInit(true);
                                }}
                                _hover={{
                                    color: branding_props.accent || "#F1F1F1",
                                    transform: "scale(1.1)",
                                }}
                                zIndex={1}
                            />
                        </Button>
                    )}
                </Stack>
            </Stack>
            <Stack w="100%" position="absolute" bottom="4vh">
                <Flex justifyContent={{ base: "space-evenly", md: "space-around" }} gap={4}>
                    <Stack align="center">
                        <Text
                            color={branding_props.brand_text || "#FFFFFF"}
                            fontSize="1.2vh"
                            fontWeight={400}
                        >
                            Desarrollado por
                        </Text>
                        <Image
                            alt="logo"
                            src={branding_props.logo_developer}
                            maxH="5vh"
                            h={isGreaterThanMd && orientation == "portrait" ? "3vh" : "auto"}
                            maxW={{
                                base: "20vw",
                                md: isGreaterThanMd && orientation == "portrait" ? "25vw" : "8vw",
                            }}
                        />
                    </Stack>
                    {isGreaterThanMd && orientation === "landscape" && (
                        <Stack align="center" textAlign="center">
                            <Text
                                color={branding_props.brand_text || "#FFFFFF"}
                                fontSize="1.2vh"
                                fontWeight={400}
                            >
                                Copyright © 2025 © All Rights Reserved - Powered by Grupo guia
                                <br />
                                {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
                                <a
                                    href="/Aviso-de-privacidad"
                                    style={{
                                        color: branding_props?.brand_text || "#FFFFFF",
                                        fontSize: "1.2vh",
                                    }}
                                >
                                    Aviso de privacidad
                                </a>
                            </Text>
                        </Stack>
                    )}
                    <Stack align="center">
                        <Text
                            color={branding_props.brand_text || "#FFFFFF"}
                            fontSize="1.2vh"
                            fontWeight={400}
                        >
                            Comercializado por
                        </Text>
                        <Image
                            alt="logo"
                            src={
                                branding_props?.logo_broker ||
                                "https://media.grupoguia.mx/vision/logo/grupo-guia.svg"
                            }
                            maxH="5vh"
                            h={isGreaterThanMd && orientation == "portrait" ? "3vh" : "auto"}
                            maxW={{
                                base: "20vw",
                                md: isGreaterThanMd && orientation == "portrait" ? "25vw" : "8vw",
                            }}
                        />
                    </Stack>
                </Flex>
                {(!isGreaterThanMd || (isGreaterThanMd && orientation == "portrait")) && (
                    <Stack align="center" textAlign="center" pt="2vh">
                        <Text
                            color={branding_props.brand_text || "#FFFFFF"}
                            fontSize="1.2vh"
                            fontWeight={400}
                        >
                            Copyright © 2025 © All Rights Reserved - Powered by Grupo guia
                            <br />
                            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
                            <a
                                href="/Aviso-de-privacidad"
                                style={{
                                    color: branding_props?.brand_text || "#FFFFFF",
                                    fontSize: "1.2vh",
                                }}
                            >
                                Aviso de privacidad
                            </a>
                        </Text>
                    </Stack>
                )}
            </Stack>
        </Box>
    );
};

export default Inicio_v2;
